export const WEEKLY_PROGRAM_REFRESH_EVENT = 'haftalik-program:refresh';

export const notifyWeeklyProgramUpdated = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(WEEKLY_PROGRAM_REFRESH_EVENT));
};
